import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { DragSource } from 'react-dnd';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  disabled: false
};
const propTypes = {
  disabled: PropTypes.bool,
  connectDragSource: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired
};

const DraggableWrapper = ({ disabled, connectDragSource, children }) =>
  connectDragSource(
    <div
      className={cx('dragWrapper', {
        disabled
      })}
    >
      {children}
    </div>
  );

DraggableWrapper.defaultProps = defaultProps;
DraggableWrapper.propTypes = propTypes;
const spec = {
  // TODO: add rule to disable if more than 10
  canDrag: props => !props.disabled,

  beginDrag: props => ({ id: props.id, dragType: 'DRAG_REPORT' })
};
const collect = (connector, monitor) => ({
  connectDragSource: connector.dragSource(),
  isDragging: monitor.isDragging()
});
export default DragSource('DRAG_REPORT', spec, collect)(DraggableWrapper);



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/components/DraggableWrapper.jsx